import { useTran } from "@/hooks";

const ESGReportTableOfContents = () => {
  const { t } = useTran();
  const sections = [
    { number: 1, title: t("Framework Overview") },
    { number: 2, title: t("Sustainability Strategy") },
    { number: 3, title: t("Summary of Disclosures by Pillar") },
    { number: 4, title: t("Environmental Performance") },
    { number: 5, title: t("Social Performance") },
    { number: 6, title: t("Governance Performance") },
    { number: 7, title: t("Appendix") },
  ];

  return (
    <div
      className="esg-page-break esg-avoid-break bg-white p-12"
      style={{ minHeight: "100vh" }}
    >
      <h2 className="mb-8 text-3xl font-bold text-slate-900">
        {t("Table of Contents")}
      </h2>

      <div className="space-y-4">
        {sections.map((section) => (
          <div
            key={section.number}
            className="esg-toc-item flex items-baseline justify-between gap-4 pb-3"
          >
            <div className="flex flex-1 items-baseline gap-3">
              <span className="min-w-[2rem] text-lg font-bold text-slate-900">
                {section.number}.
              </span>
              <span className="text-lg font-semibold text-slate-700">
                {section.title}
              </span>
            </div>
            <div className="flex-1 border-b border-dotted border-slate-300 mb-1" />
            <span className="min-w-[2rem] text-right text-lg text-slate-500">
              -
            </span>
          </div>
        ))}
      </div>

      <div className="mt-12 rounded-lg border border-slate-200 bg-slate-50 p-4">
        <p className="text-xs text-slate-600 leading-relaxed">
          {t(
            "This report presents our sustainability performance across Environmental, Social, and Governance dimensions. Data is organized by disclosure framework requirements and includes supporting evidence where applicable.",
          )}
        </p>
      </div>
    </div>
  );
};

export default ESGReportTableOfContents;
